module.exports = __webpack_public_path__ + "img/purple-rose.e057b032.svg";